import { render, staticRenderFns } from "./trivia_session_live_component.vue?vue&type=template&id=637375d6&scoped=true"
import script from "./trivia_session_live_component.vue?vue&type=script&lang=js"
export * from "./trivia_session_live_component.vue?vue&type=script&lang=js"
import style0 from "./trivia_session_live_component.vue?vue&type=style&index=0&id=637375d6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637375d6",
  null
  
)

export default component.exports